import React from "react";
import { Header } from "@/features/home/components/header"
import { Sidebar } from "@/features/home/components/side-bar"
import { InvitationNavigation } from "@/features/my-data/components/invitation-navigation";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import errorlogo from "@/assets/error_apology.svg";

export const Http404Error = () => {
  const directHome = () => {
    window.location.href = EndpointPathNames.HOME;
  };

  return (
    <>
      <Header
        doAction={() => {}}
      />
      <Sidebar />
      <InvitationNavigation />
      <main className="page_404">
        <header className="title">
          <h2>404 Not found</h2>
        </header>
        <div className="type404">
          <h3 className="btn-search">
            お探しのページは見つかりません
          </h3>
          <figure>
            <img src={errorlogo} alt="404 Not Found" />
          </figure>
          <p>
            申し訳ありませんが、ページが削除されたか、URLが変更されているためご利用になれません。
          </p>
          <nav>
            <a onClick={directHome}>ホームに戻る</a>
          </nav>
        </div>
      </main>
    </>
  );
};
